<script lang="ts">
	import Mute from '$lib/icons/mute.svelte';
	import Unmute from '$lib/icons/unmute.svelte';
	import { onMount } from 'svelte';
	import Button from '$lib/buttons/v3/button.svelte';

	interface Props {
		videoElement: HTMLVideoElement;
	}

	let { videoElement }: Props = $props();
	let ButtonType = $state(Mute);

	export function handleMuteControl() {
		if (!videoElement) return;

		videoElement.muted = !videoElement.muted;
	}

	function volumeChange() {
		if (!videoElement) return;

		ButtonType = videoElement.muted ? Mute : Unmute;
	}

	onMount(() => {
		if (!videoElement) return;

		videoElement.addEventListener('volumechange', volumeChange);

		return () => {
			videoElement.removeEventListener('volumechange', volumeChange);
		};
	});
</script>

<Button class="btn-blur" onclick={handleMuteControl}>
	<ButtonType class="h-5 w-5 text-stone-5" />
</Button>
